import merge from 'lodash-es/merge'
import omitBy from 'lodash-es/omitBy'

export interface TinymceConfig {
  menubar?: boolean
  plugins?: string
  placeholder?: string
  placeholder_tag?: string
  placeholder_attrs?: {
    style: any
  }
  toolbar?: string | false
  statusbar?: boolean
  branding?: boolean
  height?: number
  content_css?: string
  browser_spellcheck?: boolean
  relative_urls?: boolean
  convert_urls?: boolean
  remove_script_host?: boolean
  inline?: boolean
  readonly?: boolean
  contenteditable?: boolean
  smart_paste?: boolean
  link_assume_external_targets?: boolean | 'http' | 'https'
  extended_valid_elements?: string
  custom_elements?: string
  theme?: string
  elementpath?: boolean
  resize?: boolean | 'both',
  contextmenu?: false | string
}

export function tinymceConfig(opts?: TinymceConfig): TinymceConfig {
  const defaults = {
    menubar: false,
    plugins: 'lists fullscreen placeholder link',
    placeholder: "",
    placeholder_tag: 'placeholder',
    placeholder_attrs: {
      style: {
        position: 'absolute',
        top: '8px',
        left: '8px',
        color: "#999"
      }
    },
    toolbar: 'bold italic underline | numlist bullist',
    statusbar: false,
    branding: false,
    height: 290,
    content_css: '/assets/components/tinymce/keyword-form.css',
    browser_spellcheck: false,
    relative_urls: false,
    convert_urls: false,
    remove_script_host: false,
    link_assume_external_targets: 'https',
    contextmenu: false
  }

  const config = omitBy(merge(
    defaults,
    opts,
  ),
  (value) => value === null)

  return config
}
